enum ImageResponseType {
    Image = 1,
    ShortName = 2
}

export default ImageResponseType;